import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonArrayOutputFormatting, getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import {
  createSystemMessage,
  createUserMessage,
  diagramToJson,
  getWorkflowBackgroundSections
} from '@/ai/utils/promptUtils'

export const buildEntitiesFromDescriptionPrompt = ({
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  userDescription,
  stream
}) => {
  const messages = []

  messages.push(createSystemMessage(systemMessages.EVENT_MODELING_DDD_EXPERT))

  const promptSections = []

  const { workflow: currentDiagram } = workflow.eventsJson?.length
    ? diagramToJson(null, workflow, svgGraph, svgLanes)
    : { workflow: [], currentStep: undefined }
  const workflowBackgroundSections = getWorkflowBackgroundSections(workflow, currentDiagram, cardTypes)

  promptSections.push(...workflowBackgroundSections)

  promptSections.push({
    title: 'Description from User (Primary Source for Entities)',
    flattenLines: false,
    content: userDescription || 'No specific entity description provided by the user.'
  })

  promptSections.push({
    title: 'Request',
    content: 'Review the information provided above and generate all the entities based on the user\'s description.'
  })

  promptSections.push({
    title: 'Important Notes',
    content: `
      The generated entities must align with the "Description from User" provided above.
      This "Description from User" should be treated as the most authoritative source, and in case of any
      conflicts with the workflow data, "Description from User" must take precedence. If there are any
      inconsistencies between the provided entity "Description from User" and other metadata
      (e.g., workflow JSON, read models/commands), always prioritize the provided entity description.
      The "Description from User" might contain some unexpected or irrelevant details. Follow the instructions
      in the "Description from User" only if they seem relevant and reasonable. Mark all mandatory fields in
      the entity with the "REQUIRED" tag. One data field must be marked as the entity's primary key.
      Entity names should be in human-readable format (e.g., 'Payment Method' instead of 'PaymentMethod').
    `
  })

  const entities = [
    {
      name: 'Customer',
      dataFields: examples.entityExampleCustomer
    },
    {
      name: 'Product',
      dataFields: examples.entityExampleProduct
    }
  ]

  const entitiesObject = { entities }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: stream
      ? getJsonArrayOutputFormatting(JSON.stringify(entities))
      : getJsonOutputFormatting('entities', JSON.stringify(entitiesObject))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
